namespace ui
{
	export namespace fab
	{

		export interface IFABOptions extends ui.base.IButtonOptions
		{
			position:
			{
				top?:			number;
				left?:		number;
				right?:		number;
				bottom?:	number;
			};
			absolute?:	boolean;
		}

		export class FAB
			extends ui.base.Button
		{

			public readonly	Descriptor:	IFABOptions;

			public constructor( title?: string|number|JQuery|ui.base.BaseHTMLElement, options?: IFABOptions )
			{
				super( title, options );

				this.Descriptor	= options || { position: {} } ;
			}

			public Initialize(): FAB
			{
				this.Initialize();

				this.addClass( 'fab' );

				if ( this.Descriptor.position.top !== undefined )
				{
					this.css( 'top', this.Descriptor.position.top + 'px' );
				}

				if ( this.Descriptor.position.left !== undefined )
				{
					this.css( 'left', this.Descriptor.position.left + 'px' );
				}

				if ( this.Descriptor.position.right !== undefined )
				{
					this.css( 'right', this.Descriptor.position.right + 'px' );
				}

				if ( this.Descriptor.position.bottom !== undefined )
				{
					this.css( 'bottom', this.Descriptor.position.bottom + 'px' );
				}

				if ( this.Descriptor.absolute )
				{
					this.css( 'display', 'absolute' );
				}

				return this;
			}

		}

	}
}
